/**
 * ============================================================================
 * [P1-02] OfflineIndicator Component
 *
 * 오프라인 상태 표시 컴포넌트
 * - 네트워크 연결이 끊어지면 상단에 알림 표시
 * - navigator.onLine API 사용
 *
 * Accessibility:
 * - role="alert" 사용
 * - aria-live="polite" 사용
 * ============================================================================
 */

import { useState, useEffect } from 'react'
import styles from './Layout.module.css'

// ============================================================================
// [P1-02] OfflineIndicator 컴포넌트
// ============================================================================
export function OfflineIndicator() {
  // 초기 상태를 navigator.onLine으로 설정 (SSR 대비 기본값 true)
  const [isOnline, setIsOnline] = useState(() => {
    if (typeof navigator !== 'undefined') {
      return navigator.onLine
    }
    return true
  })

  // ========================================================================
  // 온라인/오프라인 상태 감지
  // ========================================================================
  useEffect(() => {
    // 이벤트 핸들러
    const handleOnline = () => {
      console.log('[OfflineIndicator] 온라인 상태로 전환')
      setIsOnline(true)
    }

    const handleOffline = () => {
      console.log('[OfflineIndicator] 오프라인 상태로 전환')
      setIsOnline(false)
    }

    // 이벤트 리스너 등록
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // 온라인 상태면 렌더링하지 않음 (but DOM은 유지하여 애니메이션 처리)
  return (
    <div
      className={`${styles.offlineIndicator} ${!isOnline ? styles.visible : ''}`}
      role="alert"
      aria-live="polite"
      aria-hidden={isOnline}
    >
      <span className={styles.offlineIcon} aria-hidden="true">
        📡
      </span>
      <p className={styles.offlineText}>
        오프라인 상태입니다. 일부 기능이 제한됩니다.
      </p>
    </div>
  )
}

// ============================================================================
// 기본 export
// ============================================================================
export default OfflineIndicator
